// extracted by mini-css-extract-plugin
module.exports = {"flex":"Register_flex__1HQgo"};